import * as React from 'react'

/**
 * @description PrizeCup icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { PrizeCup } from '@sravni/design-system-icons'
 *
 * <PrizeCup />
 * ```
 */
export const PrizeCup = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="PrizeCup" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.857 15v-2.998c-1.265-.476-2.166-1.451-2.746-2.63-.91-1.855-1.457-3.298-1.54-5.8 0-.715.715-1.429 1.429-1.429h10c.714 0 1.428.714 1.428 1.429-.082 2.502-.629 3.945-1.54 5.8-.66 1.342-1.48 2.154-2.745 2.63V15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M4.572 4.286H2.089a.374.374 0 0 0-.374.394c.073 1.629.575 3.021 1.451 4.026.843.97 2.319 1.503 3.549 1.503M17.429 4.286h2.483a.374.374 0 0 1 .373.394c-.072 1.629-.574 3.021-1.45 4.026-.843.969-2.319 1.502-3.549 1.502M14.929 15H7.07C6.677 15 6 15.677 6 16.071v.715c0 .394.677 1.071 1.071 1.071h7.858c.394 0 1.071-.677 1.071-1.071v-.715c0-.394-.677-1.071-1.071-1.071Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M13.143 7.143c0 .714-.714 1.429-1.428 1.786"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
